import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Hidden from "@mui/material/Hidden";
import PropTypes from "prop-types";
import CNVOverviewTable from "./CNVOverviewTable";

const menuItems = ["OVERVIEW", "GENE INFO", "IGV"];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cnv-tabpanel-${index}`}
      aria-labelledby={`cnv-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `cnv-tab-${index}`,
    "aria-controls": `cnv-tabpanel-${index}`,
  };
}

function CNVDetailTabs(props) {
  const [activeMenu, setMenu] = React.useState(0);

  const handleChange = (event, newMenu) => {
    setMenu(newMenu);
  };

  return (
    <>
      <Box>
        <Tabs
          orientation="horizontal"
          value={activeMenu}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              height: "4px",
              background: "#171A1E",
            },
          }}
        >
          {menuItems.map((text, index) => (
            <Tab
              key={text}
              label={<Hidden smDown>{text}</Hidden>}
              iconPosition="start"
              sx={{
                "&.Mui-selected": {
                  background: "white",
                  color: "#171A1E",
                },
              }}
              {...a11yProps(index)}
              disabled={index === 1 || index === 2}
            />
          ))}
        </Tabs>
      </Box>
      <Box>
        <TabPanel value={activeMenu} index={0}>
          <CNVOverviewTable cnv={props.cnv} />
        </TabPanel>
        <TabPanel value={activeMenu} index={1}>
          <Box sx={{ p: 2 }}>
            <div>Gene Information - Coming Soon</div>
          </Box>
        </TabPanel>
        <TabPanel value={activeMenu} index={2}>
          <Box sx={{ p: 2 }}>
            <div>IGV Viewer - Coming Soon</div>
          </Box>
        </TabPanel>
      </Box>
    </>
  );
}

export default CNVDetailTabs;
